<template>
    <div id="shootPlan">
        <l-map ref="map" :maxBounds="maxBounds" :zoom="zoom" :center="center" :options="option">
            <l-tile-layer ref="mapLayer" :url="mapUrl" :options="mapSubdomains" />
            <l-tile-layer ref="mapLayer" :url="infoUrl" :options="mapSubdomains" />
            <template v-for="item in planList">
                <l-boundary-canvas
                    :key="item.imagingGeometry"
                    :url="this.globalJS.world1mUrl_2021"
                    :geojson="JSON.parse(item.imagingGeometry)"
                    :tms=true
                />
                <l-geo-json
                    :key="item.imagingGeometry + 'geo'"
                    :geojson="JSON.parse(item.imagingGeometry)"
                    :optionsStyle="geojsonStyle"
                    @click="openInfoPopup(item)">
                    <l-popup>Hello!</l-popup>
                </l-geo-json>
            </template>
        </l-map>
    </div>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer, LGeoJson} from 'vue2-leaflet';
import LBoundaryCanvas from "@/components/Vue2LeafletBoundaryCanvas";
import center from '@turf/center';

export default {
    name: 'ShootPlan',
    components: {
        LMap,
        LTileLayer,
        LGeoJson,
        LBoundaryCanvas
    },
    data(){
        return{
            zoom: 5,
            center: L.latLng(34.33134114681686, 121.88232421875001),
            maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
            option: {zoomControl: false, attributionControl: false, renderer: L.canvas()},
            mapUrl:'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543',
            infoUrl:'https://t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543',
            mapSubdomains:{subdomains: ['0', '1', '2', '3']},
            geojsonStyle: {
                color: '#F44336',
                weight: 2,
                fillOpacity: 0
            },
            planList:[
                {
                    imagingGeometry:'',
                }
            ]
        }
    },
    methods:{
        getPlanList(date){
            this.$http.get('/earthApi/shootInfo/getShootInfoList?date=' + date).then(response => {
                this.planList = response.body.data
                // if(this.planList.length != 0){
                //     this.$refs.map.mapObject.fitBounds(L.geoJSON(JSON.parse(this.planList[0].imagingGeometry)).getBounds())
                // }
            })
        },
        openInfoPopup(plan){
            console.log(center(JSON.parse(plan.imagingGeometry)))
            const centerPoint = center(JSON.parse(plan.imagingGeometry)).geometry.coordinates;
            L.popup({closeButton:false, className:'popup'})
                .setLatLng({lng:centerPoint[0], lat:centerPoint[1]})
                .setContent('<img height="10" style="margin-right: 6px; transform: translateY(1px)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAAsUlEQVQ4T+WUsQ3CMBBF3x+DCWgQM7AEKzADHaFjBlZIxwSZAdEwAWN8dJIdhcgpDEFCwpKrOz/9O999UTi2D8Am3VJKB3SSjuOgJoA34AqcS3FgB6wlrSaBthfAUlJn20BTUhCAVEHEFe8kPTK4VzhKqgG+5M4PtH0B9sA2lRllVCsEWuDUP049yH15BxiI5k+B835KHsjfncOBwlg9Yo0q5zBM5J7X73vmMHSNT+zrCVIj9l8cim5SAAAAAElFTkSuQmCC" />' + plan.imagingMode + '<br/>' + '<img height="10" style="margin-right: 6px; transform: translateY(1px)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaUlEQVQ4T42TTSsFcRTGf8+H8BmUFGsLZKGshNyyuB9Ad2fHwsuWklI+gJRyy4Jkh+yUjdQtCy9FCRvZWD46039uY8y9mZpm5pw5v3Oec85fVFy2l4BBSbXcbXsWWAYmJT3kdpXjbc8DO8neDEgKPki2K2BK0mt8/wLYrgO7wALwAkRQE4js8Yw7bOfAtKTPMiCcA0BN0k0hc1ZJZCzYToCZKgkBGQNCSlZBsRclSPMPIP0QgVnZ5eCCfyiTUdHEcBwCl12CJ5LM0ypAZO5Uetj7gFYO7yThD8R23pvhlCCDlKcwmiSNAKv5LqRnQGM6TdtRRQBbsh1BQXu3HfP9Bp6AN+AL2ATugP0EbQA96X0xAEfAmaQt2/3AbVqiuqQL23PAjaSW7ZVCZQ1JOwHYAMYlxQLFogRkG1gLQMWUAnIvaa+9yravgWNJa1WHq5ut3UTbj8AHEIdlXdLzf2DlKYSc3mhcVflVwB8xIrALI2qVSQAAAABJRU5ErkJggg==" />吉林一号·'+ plan.satelliteId + '<br/><img height="10" style="margin-right: 6px; transform: translateY(1px)" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABoklEQVQ4T42TTYiPURSHn2cjK7aEorBg4Xs9JoWV5SAfC/KxYmMWs0KpSaSwoUS+SpZ2lFhJSSw0G4qiFCvsLBz9pns1/eef5tR9395zz/ucc8/5XWlWVWuAh8CUOtb9M99Vlf3EjalT2TOPqtoKPGvBV4FLQHwjzZe9rFPAieYbVZ878PM54DtwGXjdVuI3tXUU+AWcBVYDowG8A9YCR4CTwB9gXH0yUP524AIwHzgIvAReBHAaeAqcT0a1l5ijZQ81Gaetqq60PqTakd6DfOxWVw1knQVokPdJqN7ogHT0lpoS/9mwChpgHNio7s0RFgA/gJ3q4zkCdgC31UUBbAZeAQvVn0MAZ5rvpnq4VdCTrgtgCfAF2KC+HRRQG3Pc37p4qmo98AZY2nvwAbioXhumwCHQ4xGVurIDrgOL1V1zBDwCvqrHOmA58BHYr97/H6Sq9gH3gBXqp2lAa0xmnobdVaO0WVZVd4ADievi6hVMAnuaxgPKNKLOTCe2BdgGpPtRZWIeqBMdEEfG9Lmq5gETMy5QAP1iTaq/q2oZcChV/AXgWrvPY7xwvAAAAABJRU5ErkJggg==" />' + plan.imagingStart.substring(plan.imagingStart.length-8) + ' ~ ' + plan.imagingEnd.substring(plan.imagingEnd.length-8))
                .openOn(this.$refs.map.mapObject);
        }
    },
    mounted() {
        window.leaflet = this;
        this.getPlanList(new Date().toLocaleDateString().replace(/\//g,'-'))
    }
}
</script>

<style lang="scss" scoped>

.leaflet-popup-content-wrapper, .leaflet-popup.tip {
    background: rgba(0,0,0,0.25)
}

#shootPlan {
    font-family: 微软雅黑;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;
}

</style>
